import { createAsyncThunk } from '@reduxjs/toolkit';
import getItems from '../selectors/getItems';
import getUnenhancedOpenPurchase from '../selectors/getUnenhancedOpenPurchase';
import choiceSelectionsFromBase from '../utils/ordering/choiceSelectionsFromBase';
import { getUnavailableChoiceIds } from '../selectors/getUnavailableChoiceIds';

export const resetOpenPurchaseChoiceSets = createAsyncThunk(
  '$resetOpenPurchaseChoiceSets',
  async (
    data: {
      targetChoiceSetIds: string[];
    },
    { getState, rejectWithValue },
  ) => {
    try {
      const { targetChoiceSetIds } = data;

      const openPurchase = getUnenhancedOpenPurchase(
        getState() as EntireFrontendState,
      );

      let adjustedPurchase: _Purchase;

      const state = getState() as EntireFrontendState;
      const items = getItems(state);
      const item = items![openPurchase?.sizeId ?? openPurchase!.itemId] as Item;

      // Same as openPurchase — skip unavailable choices when computing the default
      // so a reset doesn't re-introduce an unavailable selection.
      const unavailableIds = getUnavailableChoiceIds(item.choiceSets, state);

      const defaultChoiceSelections = choiceSelectionsFromBase(
        item.choiceSets,
        undefined,
        undefined,
        unavailableIds,
      );

      let newChoiceSelections: ChoiceSelections = {
        ...(openPurchase!.choiceSelections as ChoiceSelections),
      };

      targetChoiceSetIds.forEach(choiceSetId => {
        newChoiceSelections[choiceSetId] = defaultChoiceSelections[choiceSetId];
      });

      adjustedPurchase = {
        ...openPurchase!,
        choiceSelections: newChoiceSelections,
      };

      return {
        purchase: adjustedPurchase,
      };
    } catch (e) {
      console.error('Reset open purchase choice sets failed', { e });
      return rejectWithValue(e);
    }
  },
);
